module.exports = __webpack_public_path__ + "img/24.eaca73f8.jpg";